(() => {
  document.querySelectorAll('.yellow-drl-page .compare').forEach((compare) => {
    const slider = compare.querySelector('input[type="range"]');
    if (!slider) return;

    const setComparePosition = () => {
      const yellowVisible = Number(slider.value);
      compare.style.setProperty('--position', `${100 - yellowVisible}%`);
      slider.setAttribute('aria-valuetext', `${yellowVisible}% Gelb sichtbar, Rest Weiß`);
    };

    setComparePosition();
    slider.addEventListener('input', setComparePosition);
    slider.addEventListener('change', setComparePosition);
  });
})();
